import api from '@/services/api';

// base ohne führendes /api, da der HTTP-Client bereits /api als baseURL nutzt
const base = '/teacher-infos';

export default {
    list(params = {}) {
        return api.get(base, { params }).then(r => r.data);
    },
    create(payload) {
        return api.post(base, payload).then(r => r.data);
    },
    update(id, payload) {
        return api.put(`${base}/${id}`, payload).then(r => r.data);
    },
    markRead(id) {
        return api.post(`${base}/${id}/read`).then(r => r.data);
    },
    markNotificationCreated(id) {
        return api.post(`${base}/${id}/notification-created`).then(r => r.data);
    },
    unreadCount() {
        return api.get(`${base}/unread-count`).then(r => r.data);
    },
};
